<template>
  <div class="tableview">
    <vk-card class="table-card">
      <h1>
        Tabulato 
      </h1>
      <p v-if="data != null && data.rows != null && data.rows.length > 0">
        <b>
          {{ data.rows.length }} records nella query
          <br>
          {{ tableData.rows.length }} records visibili (più recenti)
          <br>
        </b>
      </p>
      <p v-else>
        Nessun record nella query specificata: usare il pannello in basso a sinistra dell'interfaccia per specificare un periodo e dei device,
        quindi premere "Aggiorna" per effettuare la query (i cui risultati saranno visibili in questa schermata, nel grafico e come percorsi nella mappa).
      </p>

      <div class="scrollable-table">
        <table v-if="data != null && data.rows != null && data.rows.length > 0" class="uk-table uk-table-hover uk-table-small">
          <thead>
            <tr>
              <th v-for="col in wantedColumns" v-bind:key="data.columns[col].label">
                {{ data.columns[col].label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in tableData.rows" v-bind:key="row[0]">
              <td v-for="col in wantedColumns" v-bind:class="{ device_id: (col == 2), device_label: (col == 3) }">
                {{ renderValue(row[col], col) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </vk-card>
  </div>
</template>

<style lang="scss">
  .table-card {
    height: 100%;
  }

  .scrollable-table {
    overflow-y: scroll;
    height: 600px;
  }

  .device_id {
    font-family: monospace;
    font-size: 0.9em;
  }

  .device_label {
    font-weight: bold;
  }
</style>

<script>
import config from '@/config'
import { timestampToReadable, decimalToHex } from '@/utils'

export default {
  name: 'tableview',

  components: { },

  beforeCreate () {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },

  data () {
    return {
      wantedColumns: config.TABLE_COLUMNS
    }
  },

  computed: {
    data () {
      return this.$store.state.queryLastResult
    },

    tableData () {
      if (this.data.rows.length <= config.TABLE_RECORDS_LIMIT) {
        return this.data
      } else {
        return {
          columns: this.data.columns,
          rows: this.data.rows.slice(0, config.TABLE_RECORDS_LIMIT)
        }
      }
    }
  },

  methods: {
    refresh () {
      this.$store.dispatch('REFRESH_QUERY', this.$http)
    },

    renderValue (value, col) {
      if (col == 2) // ID
        return value.substr(0, 12)
      else if (col == 1) // Timestamp
        return timestampToReadable(value)
      else if (col == 6) // Virtual
        return value ? "si" : "no"
      else if (this.data.columns[col].type == "errorbits")
        return '0x' + decimalToHex(value, 4)
      else
        return value
    }
  }
}
</script>
